import React from 'react';
import { observer } from 'mobx-react-lite';
import { iframeService, isMobile } from '@pascal/pascal-core';
import { AdditionalInputValueChangingButtons } from '@pascal/pascal-core/shared/core/enums/additionalInputValueChangingButtons';

const BetInputSection = observer(
  ({
    onBlur,
    onChange,
    betAmount,
    handleOpenNumPad,
    showNotification,
    setIsValidatedAmount,
    handleChangeInputValue,
  }) => {
    return (
      <div className='monti-calc-input-holder'>
        <div className='monti-calc-input-inside'>
          <div
            className='monti-calc-input-button left'
            onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.minus)}
          >
            <div className='monti-calc-input-button-inside'>
              <i className='ui-lib-minus' />
            </div>
          </div>
          <input
            type='text'
            maxLength={9}
            autoComplete='off'
            readOnly={isMobile()}
            value={betAmount || ''}
            className='monti-calc-input'
            title={`${betAmount || ''}`}
            inputMode={isMobile() ? 'none' : 'text'}
            onBlur={() => {
              const { validatedBetAmount, errorMessageCode } = onBlur(betAmount);
              if (errorMessageCode) {
                showNotification({ responseCode: errorMessageCode });
                setIsValidatedAmount(true);
                setTimeout(() => setIsValidatedAmount(false), 100);
              }
              iframeService.sendStakeUpdate(validatedBetAmount);
              onChange(validatedBetAmount);
            }}
            onChange={(e) => {
              if (
                /^([0]{1}|([1-9]{1}\d*))(?:\.\d{0,2})?$/.test(e.target.value) ||
                e.target.value === ''
              ) {
                onChange(e.target.value.replace(',', '.'));
              }
            }}
            {...(isMobile() ? { onClick: (e) => handleOpenNumPad(e) } : {})}
          />
          <div
            className='monti-calc-input-button right'
            onClick={() => handleChangeInputValue(AdditionalInputValueChangingButtons.plus)}
          >
            <div className='monti-calc-input-button-inside'>
              <i className='ui-lib-plus' />
            </div>
          </div>
        </div>
      </div>
    );
  }
);

export default BetInputSection;
